<template>
  <!-- 郵送する書類を作った人に、封筒の宛名ラベルを勧める -->
  <SuggestLinkCard
    :link-id="linkId"
    :href="href"
    img-src="/static/img/formats/sample/atena.png"
    title="封筒の宛名ラベルも作れます"
    :lead="lead"
    cta="宛名ラベルを作る"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SuggestLinkCard from '@/components/format-edit/SuggestLinkCard.vue'

const props = defineProps<{
  /** GTM の link_click で入口を区別する id */
  linkId: string
  /** 遷移先に付ける計測用の frm。GA4 の page_location で流入元を数える */
  frm: string
  lead: string
}>()

const href = computed(
  () => `/format/atena?frm=${encodeURIComponent(props.frm)}`
)
</script>
